import { AdvanceBalanceDistributionProps } from "../hooks/advance-balance-distribution"

export const getOrigin = (selected: boolean, advanceLimits: AdvanceBalanceDistributionProps[]) => {
    const currentOrigin = selected ? 'WEB' : 'TEF_CREDITO_VENCER'
    const returnOfOrigin = advanceLimits !== null ? advanceLimits.filter((origin: AdvanceBalanceDistributionProps) => origin.advanceOrigin === currentOrigin) : []
    return returnOfOrigin[0]
}